import { Dialog, DialogClose, DialogTitle } from "@suse-o11y/dialog";
import { IconClose, IconMetrics } from "@suse-o11y/icons";
import { RemoteData } from "@suse-o11y/remote-data";
import React from "react";

import { AddToDashboardButton } from "./_add-to-dashboard-button";
import { Content, type ContentModel, type ContentProps } from "./_content";
import { PinComponentButton } from "./_pin-component-button";

interface MetricsDrawerProps extends ContentModel, Pick<ContentProps, "timestamp" | "timeRange"> {
	title: undefined | string;

	/**
	 * This is a component that will be passed to a pinned metric item.
	 */
	componentIdentifier?: string;
}

export const MetricsDrawer: React.FC<MetricsDrawerProps> = ({
	title,
	metricQueries,
	componentIdentifier,
	timestamp,
	timeRange,
	chart,
}) => (
	<Dialog className="drawer/dialog drawer-wide">
		<header className="drawer-header">
			<IconMetrics className="size-5" />

			<DialogTitle className="drawer-title mr-auto">{title}</DialogTitle>

			{componentIdentifier != null && (
				<PinComponentButton
					chart={chart}
					componentIdentifier={componentIdentifier}
					metricQueries={metricQueries}
					timestamp={timestamp}
					title={title}
				/>
			)}

			<AddToDashboardButton
				model={RemoteData.success({ title, metricQueries, chart, timestamp, componentIdentifier })}
			/>

			<DialogClose aria-label="Close" className="button button-square">
				<IconClose className="size-3" />
			</DialogClose>
		</header>

		<Content
			className="drawer-body"
			model={RemoteData.success({ chart, metricQueries })}
			timeRange={timeRange}
			timestamp={timestamp}
		/>
	</Dialog>
);
